import React, { useState, useRef, useEffect } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "./TH.css";
import DatePicker from "react-datepicker";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import { uploadTHFile, closeAlert } from "../app/DeliveryLeadershipSlice";
import { getCurrentMonth } from "../app/DeliveryLeadershipSlice";
import { Snackbar, Typography } from "@mui/material";
import { Alert } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import LeftArrow from "@mui/icons-material/KeyboardArrowLeft";
import RightArrow from "@mui/icons-material/KeyboardArrowRight";

function TLFileUpload({ trackId }) {
  const [selectedMonth, setSelectedMonth] = useState(0);
  const [selectedDate, setSelectedDate] = useState();
  const [selectedYear, setSelectedYear] = useState(null);
  const [file, setFile] = useState(null);
  const [statusMessage, setStatusMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [severity, setSeverity] = useState(null);
  const [alert, setAlert] = useState(false);
  const response =
    useSelector((state) => state.deliveryLeadership.responseMessage) ?? "";
  const isUploaded =
    useSelector((state) => state.deliveryLeadership.isUploaded) ?? false;
  const { isLoaded, isDataSentSuccess, isDataSentFailure } =
    useSelector((state) => state.deliveryLeadership) ?? false;
  const dispatch = useDispatch();
  const ref = useRef();
  const saveFile = (e) => {
    setStatusMessage("");
    setFile(e.target.files[0]);
  };

  useEffect(() => {
    if (alert) {
      if (isLoaded) {
        setSeverity("warning");
        setStatusMessage("File uploading...Please wait.");
      } else if (isDataSentSuccess) {
        setSeverity("success");
        setStatusMessage("File Uploaded Successfully.!");
      } else {
        setSeverity("error");
        setStatusMessage(response || "Failed to upload File.!");
      }
    }
  }, [isLoaded, isDataSentSuccess, isDataSentFailure]);
  const handledateChange = (value) => {
    setSelectedDate(value);
    const date = new Date(value);
    const month = date.getMonth() + 1; // Months are zero-based, so add 1
    const year = date.getFullYear();
    setSelectedMonth(month);
    setSelectedYear(year);
  };
  const handleUpload = () => {
    if (!file || !selectedDate) {
      setStatusMessage("Please choose a file or select date.");
      setSeverity("warning");
      setAlert(true);
      return;
    } else {
      const formData = new FormData();
      setAlert(true);
      formData.append("file", file);
      dispatch(uploadTHFile(formData, selectedMonth, selectedYear, trackId))
        .then(() => {
          setFile(null); // Reset the selected file
          setSelectedMonth(0);
          setSelectedYear("");
          setSelectedDate(null);
          if (ref.current) {
            ref.current.value = null; // Reset the file input
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  useEffect(() => {
    dispatch(getCurrentMonth());
  }, []);

  return (
    <div>
      <Box>
        {alert && severity && (
          <Snackbar
            open={alert}
            onClose={() => setAlert(false)}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            style={{ marginTop: "200px" }}
            autoHideDuration={7000}
          >
            <Alert severity={severity}>{statusMessage}</Alert>
          </Snackbar>
        )}
        <Stack
          spacing={1.5}
          direction={"column"}
          alignItems={"flex-start"}
          justifyContent={"center"}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
            }}
            className="session__month_selector"
          >
            <Typography sx={{ fontSize: "15px", fontWeight: "700" }}>
              Choose Month:
            </Typography>
            <DatePicker
              selected={selectedDate}
              placeholderText="MM/YYYY"
              className="smedate-picker"
              onChange={(date) => handledateChange(date)}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              renderCustomHeader={({ date, changeYear }) => (
                <div className="custom-header">
                  <LeftArrow
                    className="arrow"
                    onClick={() => changeYear(date.getFullYear() - 1)}
                  />
                  <span>
                    {date.toLocaleString("default", { month: "long" })}{" "}
                    {date.getFullYear()}
                  </span>
                  <RightArrow
                    className="arrow"
                    onClick={() => changeYear(date.getFullYear() + 1)}
                  />
                </div>
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              type="file"
              className="th-mainData"
              accept=".xlsx"
              ref={ref}
              id="file"
              onChange={saveFile}
              name="file"
              hidden
            />
            <label
              htmlFor="file"
              className="th-mainData"
              style={{ padding: "8px" }}
            >
              Select File
            </label>
            <span className="th-file_caption" style={{ marginLeft: "8px" }}>
              {file ? file.name : " No File Selected"}
            </span>
            <Button
              className={
                loading === false
                  ? "th-upload_button_modal_active"
                  : "th-upload_button_modal_inactive"
              }
              sx={{ minWidth: "30px !important" }}
              onClick={handleUpload}
            >
              Upload
            </Button>
          </div>
        </Stack>
      </Box>
    </div>
  );
}
export default TLFileUpload;
